<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->


<template>
  <div class="wy-configurations-mock-api" v-loading="loading">
    <span>
      <span style="font-size: 14px; font-weight: bold;">API:</span>
      <el-select v-model="selectedApi" placeholder="Select an API" filterable @change="handleChange">
        <el-option
          v-for="item in apiList"
          :key="item.api"
          :label="`${item.api}${item.active?' (Active)':''}`"
          :value="item.api">
        </el-option>
      </el-select>
    </span>

    <v-jsoneditor v-model="json" :show-btns="false" :exapndedOnStart="true" mode="code" :modes="['code']" @json-change="onJsonChange()" @has-error="onJsonError()" />
    <div v-if="isChanged && !hasError" class="div-confirm-btn"><el-button class="btn-confirm" type="primary" @click="handleUpdate">Save</el-button></div>
  </div>
</template>

<script>
import VJsoneditor from 'vue-json-editor'
import {mapGetters, mapActions} from 'vuex';

//v-jsoneditor
export default {
  modalTitle: 'Company Configuration',
  components: {
      'v-jsoneditor': VJsoneditor
  },

  computed: {
    ...mapGetters(['authUser']),

    isChanged() {
      return JSON.stringify(this.json) != JSON.stringify(this.cloneJson)
    }
  },

  data() {
    return {
      loading: false,
      apiList: null,
      selectedApi: null,
      json: {},
      cloneJson: {},
      hasError: false,
      preMsgObj: null,
    };
  },

  methods: {
    ...mapActions(['fetchMockApiList', 'fetchMockApiData', 'updateMockApiData']),

    async handleChange(val) {
      this.selectedApi = val;
      this.json = await this.fetchMockApiData(this.selectedApi);
      this.cloneJson = JSON.parse(JSON.stringify(this.json));
    },

    async handleUpdate() {
      let data = {
        companyId: this.authUser.companyId,
        api: this.selectedApi,
        data: this.json
      }
      this.disabledBtn = true;
      this.loading = true;
      let res = await this.updateMockApiData(data);
      if(res.status == 200) {
        this.cloneJson = JSON.parse(JSON.stringify(this.json));
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 1000,
            showClose: true,
            customClass: 'update-success-msg',
            message: 'Updated successfully',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }        
      }
      else{
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 3000,
            showClose: true,
            customClass: 'update-failed-msg',
            message: 'Update failed',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
      this.hasError = false;
      this.loading = false;
    },

    onJsonError() {
      this.hasError = true
    },
    onJsonChange() {
      this.hasError = false
    }
  },

  async created() {
    this.loading = true;
    this.apiList = this.json = await this.fetchMockApiList();
    this.apiList.sort(function (a, b) {
      return b.active - a.active || a.api.localeCompare(b.api);
    });
    this.selectedApi = this.apiList[0].api;
    this.json = await this.fetchMockApiData(this.selectedApi);
    this.cloneJson = JSON.parse(JSON.stringify(this.json));
    this.loading = false;
  }
};
</script>

<style lang="scss">
.wy-configurations-mock-api {
  height: 100%;
  padding: 10px 15px 10px 10px;

  div.el-select {
    width: 600px;
    margin-bottom: 20px;
  }

  > div {
    height: calc(100% - 120px);

    .jsoneditor-vue {
      height: 100%;
    }
  }

  .div-confirm-btn {
    // display: inline-block;
    float: right;
    padding-top: 20px;
    padding-right: 12px;
    width: 82px;
    .btn-confirm {
      background-color: #214586;
      padding: 7px 30px 7px 30px;
    }
  }
  
  .jsoneditor.jsoneditor-mode-code {
    border: 1px solid #eee;
    border-radius: 3px;
    height: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    
    .ace_gutter {
      background-color: #eee;
    }

    .jsoneditor-menu {
      background-color: #E2ECF7;
      border-bottom: #ddd;
      padding: 7px;
      height:43px;

      > button {
        background-color: #214586;
      }

      .jsoneditor-modes {
        display: none;
      }
      .jsoneditor-poweredBy {
        display: none;
      }
    }
  }  
}
</style>
